import React, { useContext } from 'react';
import { ButtonBlockContainerProps } from './buttonBlockProps';
import { ReportingContainerBaseConfig } from '../../base';
import { ButtonBlockController, ButtonBlockLoader } from './buttonBlockInterface';
import { useForm } from 'react-hook-form';
import { ButtonBlockFormValues } from './buttonBlockModel';

export function createButtonBlockContainer(
    config: ReportingContainerBaseConfig,
    loader: ButtonBlockLoader,
    controller: ButtonBlockController
): React.FC<ButtonBlockContainerProps> {
    const {
        kernel: {
            infra: {
                toaster: { useToast },
            },
        },
        context: { useContext },
        repository: { research },
    } = config;
    return ({ as: View, ...containerProps }) => {
        const context = {
            root: useContext(),
            block: config.infra.editor.context.useContext(),
        };
        const toast = useToast();
        const mutation = research.trigger.useCreate(context.root);
        const data = loader.useLoad(context.root, containerProps);

        const form = useForm<ButtonBlockFormValues>({
            defaultValues: {
                properties: {},
            },
        });
        const props = controller.useProps(context.root, data, {
            form: {
                id: 'button-block-form',
                form,
                async onSubmit() {
                    const response = await mutation.mutateAsync({
                        button: data.block.id,
                    });
                    console.log(response);
                    form.reset();
                },
                onSubmitError(error) {
                    toast({
                        kind: 'error',
                        description: error.message,
                    });
                },
            },
            item: {
                adapter: context.block.adapter,
            },
        });
        return <View {...props} />;
    };
}
